import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './departments.loaders';
import { converters } from './departments.converters';
import { DepartmentsFilters } from './departments.types';

export const departmentsKeys = queryKeyFactory('departments');

export const useDepartments = (
  filters: Partial<DepartmentsFilters> = {},
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: departmentsKeys.list(filters),
    queryFn: () => loaders.getDepartments({ filters }),
    select: converters.getDepartments,
    ...options,
  });
};
